import { useEffect } from 'react';
import { useMap } from 'react-leaflet';

import { DARK_TILE_LAYER, OSM_TILE_LAYER, TOPO_TILE_LAYER } from './constants';

const createTileLayer = ({ url, attribution, subdomains, maxZoom }) =>
  L.tileLayer(url, { attribution, subdomains, maxZoom });

export const BaseLayers = ({
  layer = 'OpenStreetMap',
  defaultLayer = 'OpenStreetMap',
  onActiveLayer = null,
  showControl = true,
}) => {
  const map = useMap();

  const baseLayers = {
    OpenStreetMap: createTileLayer(OSM_TILE_LAYER),
    TopoMap: createTileLayer(TOPO_TILE_LAYER),
    ...(DARK_TILE_LAYER ? { Dark: createTileLayer(DARK_TILE_LAYER) } : {}),
  };

  useEffect(() => {
    if (map && onActiveLayer) {
      if (showControl) {
        const layersControl = L.control.layers(baseLayers);
        layersControl?.addTo(map);
      }

      const initialLayer = baseLayers[defaultLayer];
      initialLayer?.addTo(map);
      onActiveLayer(defaultLayer);
    }

    map.on('baselayerchange', e => {
      baseLayers[layer]?.addTo(map);
      onActiveLayer(e.name);
    });
  }, [map, defaultLayer, onActiveLayer, showControl]);

  return null;
};

export default BaseLayers;
